import * as R from "ramda";
import { call, reducer } from "../../helpers/api/meta";
import { getClassroomDashboard } from "../../helpers/api/api";

export const GET_CLASSESROOM_DASHBOARD = "GET_CLASSESROOM_DASHBOARD";

export const callGetClassroomDashboard = (inputs) => {
  // console.log("callGetClassroomDashboard");
  const meta = {
    endpoint: (params) => getClassroomDashboard(params),
    inputs,
    action: GET_CLASSESROOM_DASHBOARD,
    messages: {
      id: "classroomDashboard",
      failure: "Could not get classroom dashboard data.",
    },
  };
  return call(meta);
};

const initialState = {
  loading: false,
  results: {},
};

const messages = {
  loadFailed: "Could not load Classroom.",
};

const saveClassroomDashboard = (state, action) => {
  return R.assoc("results", action.result, state);
};

export default reducer(
  initialState,
  GET_CLASSESROOM_DASHBOARD,
  saveClassroomDashboard,
  messages.loadFailed
);
